import React from "react";
import Accordion from "../Accordion/Accordion";

import "./QAForm.css";

const QAForm = ({ props, isMobile, isTablet }) => {
  const data = props || [];
  return (
    <div className="qa-form">
      {data.map((el, index) => {
        return (
          <Accordion
            title={<div dangerouslySetInnerHTML={{ __html: el.question }} />}
            qaForm={true}
            isMobile={isMobile}
            isTablet={isTablet}
            key={el._id || el.question || index}
          >
            <div dangerouslySetInnerHTML={{ __html: el.answer }} />
          </Accordion>
        );
      })}
    </div>
  );
};

export default QAForm;
